var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['app-auth-page', 'reg-bg']},[_c('div',{attrs:{"id":"components-section"}},[_c('verify')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }